import { DatePipe } from "@angular/common";
import { Injectable, Pipe, PipeTransform } from "@angular/core";

@Injectable({
    "providedIn": "root"
  })
@Pipe({
    "name": "datewithnotimezone",
    standalone: true
})
export class DateWithNoTimeZonePipe implements PipeTransform {
    transform (value: Date, pattern: string = null): string {
        if (!value) {
            return "";
        }

        //The date will be changed to UTC and prevent the timezone influence.
        const dateValue = new Date(value);
        const dateWithNoTimezone = new Date(
            dateValue.getUTCFullYear(),
            dateValue.getUTCMonth(),
            dateValue.getUTCDate(),
            dateValue.getUTCHours(),
            dateValue.getUTCMinutes(),
            dateValue.getUTCSeconds()
        );

        //The converted UTC date is put through the date pipe to allow for any date with format to be returned as a string.
        const datePipe = new DatePipe("en-US");
        let dateString: string;
        if (pattern) {
            dateString = datePipe.transform(dateWithNoTimezone, pattern);
        } else {
            dateString = datePipe.transform(dateWithNoTimezone);
        }

        return dateString;
    }
}
